// App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import ValidationHubPage from './pages/ValidationHubPage';
import InvoiceDetailPage from './pages/InvoiceDetailPage';
import InvoiceCreatePage from './pages/InvoiceCreatePage';
import EmailViewerPage from './pages/EmailViewerPage';
import EmailListPage from './pages/EmailListPage';
import ClientsPage from './pages/ClientsPage';
import ClientDetailPage from './pages/ClientDetailPage';
import ClientCreatePage from './pages/ClientCreatePage';
import BeneficiarDetailPage from './pages/BeneficiarDetailPage';
import EndUserCreatePage from './pages/EndUserCreatePage';
import ProductCreatePage from './pages/ProductCreatePage';
import AnafInvoicesPage from './pages/AnafInvoicesPage';
import AnafExplorerPage from './pages/AnafExplorerPage';
import SendersTriagePage from './pages/SendersTriagePage';

// A special component to protect routes
function PrivateRoute({ children }) {
  const accessToken = localStorage.getItem('accessToken');
  return accessToken ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route 
          path="/validation-hub" 
          element={
            <PrivateRoute>
              <ValidationHubPage />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/invoice/:id" 
          element={
            <PrivateRoute>
              <InvoiceDetailPage />
            </PrivateRoute>
          } 
        />
        <Route
          path="/invoice/new"
          element={
            <PrivateRoute>
              <InvoiceCreatePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/invoice/:id/email"
          element={
            <PrivateRoute>
              <EmailViewerPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/emails"
          element={
            <PrivateRoute>
              <EmailListPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/senders-triage"
          element={
            <PrivateRoute>
              <SendersTriagePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/email/:id"
          element={
            <PrivateRoute>
              <EmailViewerPage />
            </PrivateRoute>
          }
        />

        {/* --- THIS IS THE FIX --- */}
        <Route 
          path="/end-users/:id" 
          element={
            <PrivateRoute>
              <BeneficiarDetailPage />
            </PrivateRoute>
          } 
        />
        {/* --- END OF FIX --- */}

        <Route 
          path="/clients/:id/end-users/new" 
          element={
            <PrivateRoute>
              <EndUserCreatePage />
            </PrivateRoute>
          } 
        />

        {/* Product edit page - now uses ProductCreatePage (works without clientId in URL) */}
        <Route
          path="/products/:productId"
          element={
            <PrivateRoute>
              <ProductCreatePage />
            </PrivateRoute>
          }
        />

        <Route 
          path="/clients/:id/products/new" 
          element={
            <PrivateRoute>
              <ProductCreatePage />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/clients" 
          element={
            <PrivateRoute>
              <ClientsPage />
            </PrivateRoute>
          }
        />
        <Route 
          path="/clients/new" 
          element={
            <PrivateRoute>
              <ClientCreatePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/clients/:id"
          element={
            <PrivateRoute>
              <ClientDetailPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/anaf-invoices"
          element={
            <PrivateRoute>
              <AnafInvoicesPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/SPVanaf-explorerSPV"
          element={
            <PrivateRoute>
              <AnafExplorerPage />
            </PrivateRoute>
          }
        />
        {/* Also support /invoices/:id for consistency */}
        <Route
          path="/invoices/:id"
          element={
            <PrivateRoute>
              <InvoiceDetailPage />
            </PrivateRoute>
          }
        />
        {/* Redirect from root to the hub if logged in, or login if not */}
        <Route path="/" element={<Navigate to="/validation-hub" />} />
      </Routes>
    </Router>
  );
}

export default App;